module.exports = __webpack_public_path__ + "img/bg13.3c6d22db.png";